import { FC, Suspense, useMemo } from 'react'
import { Route, Routes, useLocation } from 'react-router-dom'
import { TransitionGroup, CSSTransition } from 'react-transition-group'

import { HelmetLayout, RouteLoader } from 'components'
import routesList from './routes'

import styles from './RoutesWrapper.module.scss'

export const RoutesWrapper: FC = () => {
  const location = useLocation()

  const renderRoutes = useMemo(
    () =>
      routesList.map(({ element: Element, path, title }) => (
        <Route
          key={path}
          path={path}
          element={
            <Suspense fallback={<RouteLoader />}>
              <HelmetLayout key={title} title={title}>
                <Element />
              </HelmetLayout>
            </Suspense>
          }
        />
      )),
    []
  )

  return (
    <TransitionGroup component={null}>
      <CSSTransition
        key={location.pathname}
        classNames={{
          enter: styles['page-enter'],
          enterActive: styles['page-enter-active'],
          exit: styles['page-exit'],
          exitActive: styles['page-exit-active'],
        }}
        timeout={300}
        unmountOnExit
      >
        <Routes location={location}>{renderRoutes}</Routes>
      </CSSTransition>
    </TransitionGroup>
  )
}
